<!-- @format -->
<ng-container
	id="pdp-pro-tips"
	resizeDeviceBreakPoint
	(newDeviceBreakPoint)="onResize($event)">
	<h3 *ngIf="articleData.length > 0">
		<img class="hmf-m-xs"
			[src]="headerSvg"
			[alt]="altSvgText"
			loading="lazy" />
	</h3>
	<div
		*ngIf="articleData.length > 0"
		class="pro-tips-wrapper">
		<button
			*ngIf="currentIndicatorPosition !== 0"
			class="pt-prev-btn"
			aria-label="Previous item"
			(click)="moveCarouselItem('left')">
			<homefield-icon
				aria-hidden="true"
				name="chevron-left"
				fill="var(--hmf-gray50)">
			</homefield-icon>
		</button>
		<div
			class="pro-tips-carousel hmf-mx-l-s hmf-mx-s-xxs hmf-my-m"
			(scroll)="updateIndicatorPosition($event)"
			#proTipsCarousel>
			<div
				*ngFor="let article of articleData; index as i; trackBy: trackByUrl"
				class="pro-tips-carousel-item"
				[ngClass]="{
					'hmf-pl-m-0': i === 0,
					'hmf-pr-m-0 pro-tips-slide-stop': i === articleData.length - 1,
					'pro-tips-slide-stop': i % slidesToShow === 0
				}"
				draggable="false">
				<a
					*ngIf="article"
					[href]="article.url"
					target="_blank">
					<img
						[src]="article.image"
						draggable="false"
						alt=""
						loading="lazy" />
					<div class="hmf-p-s">
						<h2 class="hmf-header-bold-s hmf-mb-xxs">
							{{ article.title }}
						</h2>
						<p
							class="summary hmf-header-xs"
							[innerHTML]="article.description"></p>
					</div>
				</a>
			</div>
		</div>
		<button
			*ngIf="currentIndicatorPosition !== indicatorLength - 1"
			class="pt-next-btn"
			aria-label="Next item"
			(click)="moveCarouselItem('right')">
			<homefield-icon
				aria-hidden="true"
				name="chevron-right"
				fill="var(--hmf-gray50)">
			</homefield-icon>
		</button>
		<ol class="pro-tips-carousel-nav hmf-p-0 hmf-mx-0 hmf-mt-0">
			<li
				*ngFor="let i of carouselIndicators; index as j; trackBy: trackByFn"
				class="pro-tips-carousel-indicator hmf-p-0"
				[ngClass]="{ current: j === currentIndicatorPosition }"></li>
		</ol>
	</div>
</ng-container>
